module.exports = __webpack_public_path__ + "static/media/profile.335c3aea.png";